import { IColunasSettingsUser } from '@app/shared/utils/validar_settings_user';

export const COLUNAS_DEFAULT_MODULE_PARCEIRO = [
  {
    module: 'PAR_CLIENTE',
    colunas: [
      { field: 'codigo', active: true, removable: true },
      { field: 'parceiro.nome_razao_social', active: true, removable: false },
      { field: 'parceiro.cpf_cnpj', active: true, removable: true },
      { field: 'rg_insc_est', active: true, removable: true },
      { field: 'limite_credito', active: true, removable: true },
      { field: 'saldo_limite_credito', active: true, removable: true }
    ]
  },
  {
    module: 'PAR_PRE_CLIENTE',
    colunas: [
      {
        field: 'payload.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'payload.cpf_cnpj',
        active: true,
        removable: false
      },
      {
        field: 'vendedor.parceiro.nome_razao_social',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      },
      {
        field: 'tipo',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'PAR_FONECEDOR',
    colunas: [
      { field: 'parceiro.nome_razao_social', active: true, removable: false },
      { field: 'parceiro.cpf_cnpj', active: true, removable: true },
      { field: 'parceiro.rg_insc_est', active: true, removable: true },
      { field: 'limite_credito', active: true, removable: true },
      { field: 'saldo_limite_credito', active: true, removable: true }
    ]
  },
  {
    module: 'PAR_FABRICANTE',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'parceiro.cpf_cnpj',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.rg_insc_est',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'PAR_SUPERVISOR',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'parceiro.cpf_cnpj',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.rg_insc_est',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'PAR_VENDEDOR',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'parceiro.cpf_cnpj',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.rg_insc_est',
        active: true,
        removable: true
      },
      {
        field: 'padrao_catalogo',
        active: true,
        removable: true
      }
    ]
  }
] as IColunasSettingsUser[];
